import React, { useState } from 'react';
import { Input } from '../../../components/Input';
import styled, { useTheme } from 'styled-components';
import { PrimaryStyle } from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const PostCodeChecker = () => {
  const [postcode, setPostcode] = useState('');
  const navigate = useNavigate();
  const theme = useTheme();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    setPostcode(value);
  };

  const onGetSignal = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!postcode) {
      toast.error('Please enter a postcode');
      return;
    }
    navigate(`/postcode/${postcode}`);
  };

  return (
    <Container>
      <form onSubmit={onGetSignal}>
        <InputWrapper>
          <Title theme={theme}>Check Signal Availability</Title>
          <Input value={postcode} onChange={handleInputChange} placeholder="Enter your postcode" />
          <StyledInput type="submit" value="Check" />
        </InputWrapper>
      </form>
    </Container>
  );
};

const StyledInput = styled.input`
  ${PrimaryStyle}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 1rem;

  @media (max-width: 768px) {
    .Toastify__toast-container {
      margin-top: 2rem;
    }
  }
`;

const InputWrapper = styled.div`
  max-width: 30rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  & input {
    text-align: center;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;
